<script lang="ts" setup>
import Top from '~/components/Top/Top.vue'
import BSPillars from '~/domains/esg/strategy/components/BSPillars/BSPillars.vue'
import Priorities from '~/domains/esg/strategy/components/Priorities/Priorities.vue'
import KeyPolicies from '~/domains/esg/strategy/components/KeyPolicies/KeyPolicies.vue'
import Committee from '~/domains/esg/strategy/components/Committee/Committee.vue'

const { t, locale } = useI18n()

useHead({
  title: t('pageTitles.strategy.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.strategy.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.strategy.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.strategy.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.strategy.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.strategy.canonical.pl'),
    },
  ],
})

</script>

<template>
  <div>
    <Top
      :header="$t('strategy.top.header')"
      :subheader="$t('strategy.top.subheader')"
      :text="$t('strategy.top.text')"
      :button="{
        text: $t('strategy.top.button.text'),
        to: $t('strategy.top.button.link'),
        icon: '/icons/icon-download.svg',
        target: '_blank'
      }"
    />

    <BSPillars />

    <Priorities />

    <KeyPolicies />

    <Committee />
  </div>
</template>

<style lang="scss" scoped>
:deep(.top) {
  min-height: 55.4rem;
  margin-bottom: 1.6rem;
}

:deep(.section) {
  h3 {
    margin-bottom: 3.2rem;
    @include h10;
  }
}

@include atM {

  :deep(.top) {
    .top__item {
      max-width: 65%;
    }
  }

  :deep(.ui-header) {
    margin-bottom: 5.6rem;
  }

  :deep(.section) {
    @include h8;
    margin-bottom: 6.4rem;
  }
}
</style>
